<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-b-modal.modalDialog
          variant="success"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="card">
      <div class="card-body p-1">
        <b-row>
          <div class="col-12 col-md-3">
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder pb-0">Kênh liên kết</label>
              </template>
              <v-select
                v-model="channel_id"
                :options="dataChannel"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder pb-0">Thể loại</label>
              </template>
              <v-select
                v-model="type"
                :options="dataType"
                label="name"
                :reduce="(val) => val.code"
                placeholder="--Chọn--"
              />
            </b-form-group>
          </div>
        </b-row>
      </div>
    </div>
    <!-- List -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(name)="data">
            <span
              class="title"
              @click="edit(data.item)"
            ><b>{{ data.item.channel.name }}</b></span>
          </template>
          <template #cell(type)="data">
            {{ data.item.channel.type }}
          </template>
          <template #cell(frame)="data">
            <ul class="frame">
              <li v-for="(val, index) in data.item.content">
                <strong>{{ val.start_time }} - {{ val.end_time }}</strong>
              </li>
            </ul>
          </template>
          <template #cell(status)="data">
            <span
              v-if="data.item.status"
              class="badge badge-light-success"
            >Đang kích hoạt</span>
            <span
              v-else
              class="badge badge-light-danger"
            >Đang dừng</span>
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              variant="warning"
              @click="edit(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button
              size="sm"
              class="ms-2"
              variant="danger"
              @click="onDestroy(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of, }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="modalDialog"
      no-close-on-backdrop
      hide-footer
      :title="dialog_title"
      @close="hidenModal"
    >
      <channel-schedule-form
        :data-edit="dataEdit"
        :data-channel="dataChannel"
        @updateList="handleDialog"
      />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
  BLink,
} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import vSelect from 'vue-select';
import ChannelScheduleForm from './ChannelScheduleForm.vue';

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    ChannelScheduleForm,
    BFormGroup,
    BLink,
    vSelect,
  },
  data() {
    return {
      dialog_title: 'Thêm mới',
      dataEdit: {},
    }
  },
  setup() {
    const refListTable = ref(null);
    const tableColumns = [
      {
        key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' },
      },
      { key: 'name', sortable: false, label: 'Tên kênh' },
      {
        key: 'type', sortable: false, label: 'Thể loại', thAttr: { width: '10%' },
      },
      {
        key: 'frame', sortable: false, label: 'Khung ghi lại', thAttr: { width: '20%' },
      },
      {
        key: 'status', sortable: false, label: 'Trạng thái', thAttr: { width: '12%' },
      },
      {
        key: 'actions',
        label: 'Hành động',
        class: 'action',
        thAttr: { width: '6%' },
      },
    ];
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const dataChannel = ref([])
    const type = ref('')
    const dataType = ref([])
    const channel_id = ref('')

    const fetchAll = () => {
      loading.value = false;
      store
        .dispatch('channel/fetchall', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          card_type: 'channel_schedule',
          channel_id: channel_id.value,
          type: type.value,
        })
        .then((response) => {
          loading.value = false;
          const result = response.data;
          if (result.code === 200) {
            dataItems.value = result.data.data
            dataChannel.value = result.data.channel
            dataType.value = result.data.dataType
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([currentPage, perPage, searchQuery, channel_id, type], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value;
    };
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      dataChannel,
      type,
      dataType,
      channel_id,
    };
  },
  methods: {
    hidenModal() {
      this.$bvModal.hide('modalDialog');
      this.dataEdit = {};
    },
    handleDialog() {
      this.refetchData();
      this.$bvModal.hide('modalDialog');
    },
    edit(item) {
      this.dataEdit = item;
      this.dialog_title = 'Cập nhật';
      this.$bvModal.show('modalDialog');
    },
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa Lịch ghi tự động này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const { id } = item;
          const card_type = 'channel_schedule';
          store
            .dispatch('channel/destroy', { id, card_type })
            .then((response) => {
              const result = response.data;
              if (result.code === 200) {
                this.refetchData();
                showToast(result.message, { variant: 'success' });
              } else {
                showToast(result.message);
              }
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
